export const SET_IS_MOBILE = 'app/SET_IS_MOBILE';
export const SET_THEME = 'app/SET_THEME'
export const SET_BACKEND_TIMEOUT = 'app/SET_BACKEND_TIMEOUT'

export function setIsMobile(isMobile = false) {
  return {
    type: SET_IS_MOBILE,
    isMobile
  }
}

export function setTheme(theme) {
  return {
    type: SET_THEME,
    theme
  }
}
